import pluralize from 'pluralize';
import { useSelector } from 'react-redux';

import { selectedItemsCountSelector } from '@air/redux-selected-items';

export const ContentCollectionItemsSelected = () => {
  const selectedItemsCount = useSelector(selectedItemsCountSelector);

  if (!selectedItemsCount) {
    return null;
  }

  return (
    <div className="px-2 ads:text-primary text-14 text-gray-12" data-testid="CONTENT_COLLECTION_ITEMS_SELECTED">
      {`${selectedItemsCount} ${pluralize('item', selectedItemsCount)} selected`}
    </div>
  );
};
